'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdTrain = function MdTrain(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.5 28.4c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z m-5.9-11.8h8.4v-6.6h-8.4v6.6z m-3.2 0v-6.6h-8.4v6.6h8.4z m-5.9 11.8c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z m7.5-25c7.3 0 13.4 0.7 13.4 6.6v15.9c0 3.2-2.7 5.7-5.9 5.7l2.5 2.5v0.9h-3.4l-3.2-3.4h-6.4l-3.3 3.4h-3.7v-0.9l2.5-2.5c-3.2 0-5.9-2.5-5.9-5.7v-15.9c0-5.9 6.8-6.6 13.4-6.6z' })
        )
    );
};

exports.default = MdTrain;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/train.js
// module id = 2068
// module chunks = 168707334958949